module.exports = __webpack_public_path__ + "static/media/image_4.9bb34610.png";